import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className={`text-2xl font-bold transition-colors duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            SLOZNA BRACA
          </h1>
          
          <div className="flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-teal-500 text-white text-sm font-semibold rounded-full hover:bg-teal-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
